import { useEffect } from 'react'
import { zodResolver } from '@hookform/resolvers/zod'
import { Checkbox } from '@iveco-ti/iveco-ds'
import { FormProvider, useForm } from '@iveco-ti/iveco-ds/hook-form'
import { useTranslation } from 'react-i18next'

import { AppData, StepInfo } from '../../models/applicationConnection'
import { TermsStepForm, TermsStepSchema } from './schemas/TermsStepSchema'
import { StepWrapper } from './StepWrapper'

type TermsStepProps = {
  appData: AppData
  stepInfo: StepInfo
  onFormChange?: (isValid: boolean) => void
}

export function TermsStep({ appData, stepInfo, onFormChange }: TermsStepProps) {
  const { t } = useTranslation('common')
  const hookForm = useForm<TermsStepForm>({
    resolver: zodResolver(TermsStepSchema()),
    mode: 'onChange',
    defaultValues: { acceptTerms: false },
  })

  const acceptTerms = hookForm.watch('acceptTerms')

  useEffect(() => {
    if (onFormChange) {
      onFormChange(acceptTerms)
    }
  }, [acceptTerms, onFormChange])

  return (
    <FormProvider {...hookForm}>
      <StepWrapper appData={appData} stepInfo={stepInfo}>
        <p className="text-xl">{t('app_connection.terms.title')}</p>
        <div className="bg-gray-50 p-4 rounded-md border max-h-[180px] overflow-y-auto">
          <div className="text-sm text-gray-600 whitespace-pre-wrap">
            {t('app_connection.terms.content')}
          </div>
        </div>
        <div className="flex items-center space-x-2">
          <Checkbox
            name="acceptTerms"
            text={t('app_connection.terms.checkbox_text')}
          />
        </div>
      </StepWrapper>
    </FormProvider>
  )
}
